export { ruleCreateCommand } from './v1/rule_create';

import { ruleCreateCommand } from './v1/rule_create';

export const rulesCommands = [ruleCreateCommand];
